export const ProfileAPI = {};

const SLICE = 'profile';

ProfileAPI.item = (onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/profile`,
    method:    'GET',
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ProfileAPI.itemSettings = (onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/settings`,
    method:   'GET',
    slice:     SLICE,
    action:    'itemSettings',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ProfileAPI.updateSettings = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/settings`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'updateSettings',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ProfileAPI.itemStatistics = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/statistics`,
    method:   'GET',
    data:     data,
    slice:     SLICE,
    action:    'itemStatistics',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

